import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '../../shared/session/session.service';
import { map, switchMap } from 'rxjs/operators';
import { TokenService } from '../../authentication/token.service';
import { RpcService } from 'app/shared/http/rpc.service';

@Component({
  selector: 'ls-partner-login',
  templateUrl: './partner-login.component.html',
  styleUrls: ['./partner-login.component.scss']
})
export class PartnerLoginComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private session: SessionService,
    private token: TokenService,
    private rpc: RpcService
  ) {}

  public ngOnInit(): void {
    const companyId: number = parseInt(
      this.route.snapshot.queryParamMap.get('partner'),
      10
    );
    this.loginFromPartner(companyId);
  }

  private loginFromPartner(companyId: number): void {
    this.token
      .initPartnerToken()
      .pipe(
        switchMap(token => {
          return this.rpc
            .makeManagerCall(
              'getRestoContext',
              [companyId, 'webmanager'],
              `Bearer ${token}`
            )
            .pipe(map(context => [token, context]));
        })
      )
      .subscribe(([token, context]) => {
        this.token.setInitialContext(context);
        this.session.createSession(token);
      });
  }
}
